import { jsx as _jsx } from "react/jsx-runtime";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React from "react";
import styled, { keyframes, css } from "styled-components";
export var SlideIn = function(param) {
    var _param_bottomThreshold = param.bottomThreshold, bottomThreshold = _param_bottomThreshold === void 0 ? 100 : _param_bottomThreshold, offset = param.offset, children = param.children, fill = param.fill, constrainSize = param.constrainSize;
    return /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
        bottomThreshold: bottomThreshold,
        customizePlaceholder: /*#__PURE__*/ _jsx("div", {
            style: {
                opacity: 0
            },
            children: children
        }),
        children: /*#__PURE__*/ _jsx(AnimatedSlideIn, {
            $offset: offset,
            $fill: fill,
            $constrainSize: constrainSize,
            children: children
        })
    });
};
var AnimatedSlideIn = styled.div.withConfig({
    componentId: "sc-4582d4ef-0"
})([
    "position:relative;animation:",
    " 800ms ease-out forwards;",
    " ",
    ""
], function(props) {
    return getKeyframes(props.$offset);
}, function(param) {
    var $constrainSize = param.$constrainSize;
    return $constrainSize ? css([
        "max-width:100%;max-height:100%;"
    ]) : "";
}, function(param) {
    var $fill = param.$fill;
    return $fill ? css([
        "width:100%;height:100%;"
    ]) : "";
});
var getKeyframes = function(offset) {
    return keyframes([
        "0%{opacity:0;bottom:-",
        ";}100%{opacity:1;bottom:0;}"
    ], offset);
};
